export class GetPaymentInfoResponse {
  paymentInstrumentId: string;
  paymentValue: string;
  creditCardBrandName: string;
  creditCardBrandPublicId: string;
  paymentMethodCode?: string;
}
